export const sortSubCategories = (subCategories?: PageContent.TTagWithImageAndSubTitle[]) =>
  subCategories?.reduceRight(
    (result, category) => (category.image ? [category, ...result] : [...result, category]),
    []
  ) || [];

// it's needed because of eslint prefer-default-export rule
export default sortSubCategories;
